<section class="slice slice-navbar bg-gradient-primary" data-separator-bg="secondary"><div></div></section>

<section class="slice slice-lg">
  <div class="container">

    <div [innerHtml]="terms"></div>

  </div>
</section>
